import URLConst from '../constants/URLConst';
import { fetchJSON, secureGET, securePUT } from '../utilities/FetchHelper';

class HotelTextService {

    getHotelText(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_HOTEL_TEXT
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    putHotelText(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_HOTEL_TEXT
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        return fetchJSON(url, { ...securePUT(), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
}

export default new HotelTextService()